import { getImageDetailRef } from "tasks/api"
import updateTaskDetailUseCase from "./updateTaskDetailUseCase"

const addPhotoUseCase = async (task, files) => {
    const { data, detail } = task

    for (const file of files) {
        const ref = getImageDetailRef(data.id, `${task.id}${file.name}${Date.now()}`)
        const blob = file.type === 'camera'
            ? await compressBase64Image(file.data)
            : await compressImage(file)

        await ref.put(blob)

        const url = await ref.getDownloadURL()
        const imageDetail = { name: file.name, url }

        if (!detail.images) {
            detail.images = []
        }

        detail.images.push(imageDetail)
    }

    return updateTaskDetailUseCase(data.id, detail)
}

function compressImage(file) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = (e) => {
        img.src = e.target.result;
      };
      
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        // Ajustar el tamaño de la imagen (puedes cambiar estos valores)
        const MAX_WIDTH = 1200;
        const MAX_HEIGHT = 1200;
        let width = img.width;
        let height = img.height;
  
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
  
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
  
        // Comprimir la imagen a un formato JPEG
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg', 0.7);  // El 0.7 es la calidad (0.0 a 1.0)
      };
    });
  }

  function compressBase64Image(base64Image) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64Image;  // Aquí pasas la cadena Base64 directamente
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        // Ajustar el tamaño de la imagen (puedes cambiar estos valores)
        const MAX_WIDTH = 1200;
        const MAX_HEIGHT = 1200;
        let width = img.width;
        let height = img.height;
  
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
  
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
  
        // Comprimir la imagen a un formato JPEG
        canvas.toBlob((blob) => {
          resolve(blob);  // Retorna el Blob comprimido
        }, 'image/jpeg', 0.7);  // 0.7 es la calidad (puedes ajustarla)
      };
  
      img.onerror = (err) => reject(err);  // Maneja errores si la imagen no es válida
    });
  }

export default addPhotoUseCase